import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import DualListBox from "../../../duallistBox";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";
import CommonSelect from "../../../../core/common/commonSelect";
import Select from 'react-select'
import { Spin } from "antd";
import { Toast } from "react-bootstrap";

type Permission = { id: number; name: string };

interface User {
  id: number;
  username: string;
}

interface ServiceDivision {
  id: number;
  name: string;
}

type Admin = {
  permissions: Array<number>;
  name: string | null;

  id: number;
};

interface Option {
  value: number;
  label: string;
}

interface ErrorMessages {
  name?: string[];
}


const EditEmployeeTeamManagementList = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};
  const [chosenPermissions, setChosenPermissions] = useState<Permission[]>([]);
  const [chosenPermissions1, setChosenPermissions1] = useState<Permission[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [permissions1, setPermissions1] = useState<Permission[]>([]);
  const [users, setUsers] = useState<User[]>([]);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  const [teamName, setTeamName] = useState<string>("");
  const [serviceDivision, setServiceDivision] = useState<ServiceDivision[]>([]);
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
  const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
  const [toastMessage, setToastMessage] = useState("");
  useEffect(() => {
    if ((showSolidDangerToast || showSolidSuccessToast) === true) {
      setTimeout(() => setShowSolidDangerToast(false), 5000);
      setTimeout(() => setshowSolidSuccessToast(false), 5000);
    }
  }, [toastMessage])
  const [selectedOption1, setSelectedOption1] = useState<Option | null>(null);
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  useEffect(() => {
    console.log("selectedOption", selectedOption)
  }, [selectedOption])

  const options1: Option[] = users.map(user => ({
    value: user.id,
    label: user.username,
  }));

  const options2: Option[] = serviceDivision.map(user => ({
    value: user.id,
    label: user.name,
  }));

  const handleChange = (option: Option | null) => {
    setSelectedOption(option);
    if (option) {
      console.log('Selected ID:', option.value);
    }
  };

  const handleChange1 = (option: Option | null) => {
    setSelectedOption1(option);
    if (option) {
      console.log('Selected ID:', option.value);
    }
  };




  const handlePermissionsChange = (selected: Permission[]) => {
    setChosenPermissions(selected);
    const selectedIds = selected.map((perm) => perm.id);
    fetchPermissionsData1(selectedIds);
  };

  const handlePermissionsChange1 = (selected: Permission[]) => {
    setChosenPermissions1(selected);
  };

  const [newAdmin, setNewAdmin] = useState<Admin>({
    name: null,
    id: 0,
    permissions: [],
  });

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchTeamData = async (id: string) => {
    const response = await fetch(`${webApi}/employees/employee_user_team_management/${id}`, options);
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };

  const fetchPermissionsData = async () => {
    const resposne = await fetch(`${webApi}/employees/user_dropdown_for_team_creation/`, options);
    return await resposne.json();
  };

  const fetchPermissionsData1 = async (ids: number[]) => {
    const response = await fetch(
      `${webApi}/employees/members_dropdown_from_team_creation/?managers=${ids.join(',')}`,
      options
    );
    const data = await response.json();
    const formattedPermissions1 = data.map(
      (permission: { id: number; username: string }): Permission => ({
        id: permission.id,
        name: permission.username,
      })
    );
    setPermissions1(formattedPermissions1);
  };

  const fetchServiceDivision = async () => {
    const resposne = await fetch(`${webApi}/employees/teacher_service_division_dropdown_based_on_user/`, options);
    return await resposne.json();
  };

  const fetchData = async () => {
    setIsLoading(true); // Start loading
    try {
      const [permissionsData, teamData, groupTypesData] = await Promise.all([fetchPermissionsData(), fetchTeamData(id), fetchServiceDivision()]);

      // Convert the fetched data to the Permission type
      const formattedPermissions = permissionsData.map(
        (permission: { id: number; username: string }): Permission => ({
          id: permission.id,
          name: permission.username,
        })
      );

      setPermissions(formattedPermissions);
      setUsers(permissionsData);
      setTeamName(teamData.name);
      setServiceDivision(groupTypesData);
      const options1 = permissionsData.map((user: { id: any; username: any; }) => ({
        value: user.id,
        label: user.username,
      }));

      const options2: Option[] = groupTypesData.map((user: { id: any; name: any; }) => ({
        value: user.id,
        label: user.name,
      }));
      setSelectedOption(
        options2.find((option: { value: any; }) => option.value === teamData.service_division) || null
      );
      // setSelectedOption1(
      //   options2.find((option: { value: any; }) => option.value === teamData.team_type) || null
      // );
      setChosenPermissions(formattedPermissions.filter((permission: { id: any; }) => teamData.managers.includes(permission.id)));
      const selectedIds = teamData.managers.map((perm: any) =>
        typeof perm === 'object' && perm !== null ? perm.id : perm
      );
      await fetchPermissionsData1(selectedIds);
      setChosenPermissions1(formattedPermissions.filter((permission: { id: any; }) => teamData.members.includes(permission.id)));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    if (!checkPermission("change_employeesuserteammanagement", "employeesuserteammanagement")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData();
    }
  }, [userPermissions]);

  const updateData = async () => {
    const newTeam = {
      name: teamName,
      service_division: selectedOption ? selectedOption.value : null,
      // team_type: selectedOption1 ? selectedOption1.value : null,
      managers: chosenPermissions.map(permission => permission.id),
      members: chosenPermissions1.map(permission => permission.id),
    };
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newTeam),
    };
    const url = `${webApi}/employees/employee_user_team_management/${id}/`;
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json();
      setErrorMessage(errorData);
      setToastMessage(errorData.name);
      if (toastMessage !== "") {
        setShowSolidDangerToast(true);
      }
      throw new Error("Network response was not ok");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await updateData();
      navigate(routes.employeeTeamManagment);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTeamName(e.target.value);
  };

  useEffect(() => {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;

    // Loop over them and prevent submission
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);
  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Edit Team</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.employeeTeamManagment}>
                      Team Management List
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">Edit Team</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Row */}
          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              {/* Add Group */}
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                <div className="card-body">
                  {isLoading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        height: "100vh",
                        paddingTop: "20px",
                      }}
                    >
                      <Spin /> {/* Display loader while loading */}
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit}>
                      <div
                        className="form-group mb-3"
                        style={{
                          width: "70%",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div style={{ width: "35%" }}>
                          <label className="form-label">Team Name</label>
                          <input
                            type="text"
                            className={`form-control ${errorMessage.name ? "is-invalid" : ""
                              }`}
                            name="name"
                            placeholder="Team Name"
                            onChange={handleInputChange}
                            value={teamName}
                            required
                          />
                          {errorMessage.name && (
                            <div className="invalid-feedback">
                              {errorMessage.name[0]}
                            </div>
                          )}
                        </div>
                        <div style={{ width: "35%",marginBottom:"10px" }}>
                          <label className="form-label">Service Division</label>
                          <Select
                            value={selectedOption}
                            onChange={handleChange}
                            options={options2}
                            placeholder="Select Service Division"
                          />
                        </div>
                        {/* <div style={{ width: "28%" }}>
                        <label className="form-label">Team Type</label>
                        <Select
                          value={selectedOption1}
                          onChange={handleChange1}
                          options={options2}
                          placeholder="Select a team Type"
                          required 
                        />
                      </div> */}
                      </div>

                      <div className="form-group dual-list-box-container">
                        <label className="form-label">Select Managers</label>
                        <DualListBox
                          options={permissions}
                          selected={chosenPermissions}
                          onChange={handlePermissionsChange}
                        />
                      </div>
                      <div className="form-group dual-list-box-container">
                        <label className="form-label">Select Team Members</label>
                        <DualListBox
                          options={permissions1}
                          selected={chosenPermissions1}
                          onChange={handlePermissionsChange1}
                        />
                      </div>
                      <div className="modal-footer">
                        <Link
                          className="btn btn-primary"
                          type="submit"
                          to={routes.employeeTeamManagment}
                          style={{
                            backgroundColor: "lightcoral",
                            color: "white",
                            marginRight: "5px",
                          }}
                        >
                          Cancel
                        </Link>
                        <button
                          className="btn btn-primary"
                          type="submit"
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <i className="spinner-border spinner-border-sm"></i>
                          ) : (
                            <>Save</>
                          )}
                        </button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
              {/* /Add Group */}
            </div>
          </div>
          {/* /Row */}
          <Toast
            show={showSolidDangerToast}
            onClose={handleSolidDangerToastClose}
            id="solidDangerToast"
            className="colored-toast bg-danger text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
          <Toast
            show={showSolidSuccessToast}
            onClose={handleSolidSuccessToastClose}
            id="solidSuccessToast"
            className="colored-toast bg-success text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </div>
      </div>
    </div>
  );
};

export default EditEmployeeTeamManagementList;
